import { useEffect } from "react";

export function useShippingValidity(params: {
  showShippingDetails?: boolean;
  shippingRecipient?: string;
  shippingStreet?: string;
  shippingCity?: string;
  shippingZip?: string;
  shippingState?: string;
  shippingCountry?: string;
  onShippingValidityChange?: (isValid: boolean) => void;
}) {
  const {
    showShippingDetails,
    shippingRecipient,
    shippingStreet,
    shippingCity,
    shippingZip,
    shippingState,
    shippingCountry,
    onShippingValidityChange,
  } = params;

  useEffect(() => {
    if (!showShippingDetails) {
      onShippingValidityChange?.(true);
      return;
    }

    const isValid =
      (shippingRecipient || "").trim().length > 0 &&
      (shippingStreet || "").trim().length > 0 &&
      (shippingCity || "").trim().length > 0 &&
      (shippingZip || "").trim().length > 0 &&
      (shippingState || "").trim().length > 0 &&
      (shippingCountry || "").trim().length > 0;

    onShippingValidityChange?.(isValid);
  }, [
    onShippingValidityChange,
    showShippingDetails,
    shippingCity,
    shippingCountry,
    shippingRecipient,
    shippingState,
    shippingStreet,
    shippingZip,
  ]);
}
